import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import XLRLogger from 'src/common/helpers/logger';
import { POSModeActions } from 'src/common/redux/reducers/pos-mode-reducer';
import { setTaxRates } from 'src/items-list/business-logic/set-tax-rates';
import { warmup } from 'src/login/business-logic/service/warmup';
import { getTenderMenu } from 'src/pos-configuration/get-tender-menu';
import { getTenderExchangeConfig } from 'src/tender-exchange/business-logic/get-tender-exchanges';
import { getTouchPointNotifications } from 'src/touchpoint-notifications/get-touchpoint-notifications';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { getAllCommandMenus } from '../../command-menu/get-command-menu';
import { store } from '../../common/redux/configure-store';
import { resumeTransaction } from '../../home-page/business-logic/resume-transaction';
import { getPendingNotifications } from '../../notifications/business-logic/notification-actions-handler';

export const initializationPostUserLogin = async (): Promise<void> => {
  const alreadyInitialized = store.getState().posMode.postLoginInitialized;

  const { warmupPostLogin } = getCurrentXLRConfig();

  if (warmupPostLogin) {
    // Intentionally don't await this, just set it and forget it!
    warmup().catch(err => {
      XLRLogger.error({
        message: 'Error during warmup',
        source: 'initialization-post-user-login.ts',
        data: err,
      });
    });
  }

  await getTouchPointNotifications();

  await resumeTransaction();
  await getPendingNotifications();
  await getAllCommandMenus();

  if (!alreadyInitialized) {
    await getTenderMenu();
    await getTenderExchangeConfig();

    const { callGetEffectiveTaxRates } = getCurrentXLRConfig();
    if (callGetEffectiveTaxRates) {
      await setTaxRates();
    }
    store.dispatch(POSModeActions.setPostLoginInitialized(true));
  }

  const preferences = store.getState().user.preferences;
  if (preferences) {
    CashierPreferencesHelper.setUserPreferences(preferences);
  }
};
